export const SN_UTIL = 'util'
export const UTIL_SERVICE_STATUS_DESC_UPDATED = SN_UTIL + '/SERVICE_STATUS_DESC_UPDATED'
export const UTIL_SYSTEM_INFORMATION_UPDATED = SN_UTIL + '/SYSTEM_INFORMATION_UPDATED'